import React, { useState, useEffect } from "react";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Box,
  Grid,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  styled,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import dayjs from "dayjs";
import CustomButton from "../../component/button/button";
import CustomDataTable from "../../component/datatable/DataTable";
import OutlineCustomButton from "../../component/button/outlineButton";
import Settinglist from "../../Icon/Settinglist";
import { useDispatch, useSelector } from "react-redux";

import Message from "../../Icon/Message";
import SnackbarComponent from "../../component/snackbar/snackbar";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { useNavigate } from "react-router-dom";
import {
  GetMailTemplateAction,
  GetScheduleSendMailUsing365Action,
  GetSentMailAction,
} from "../../Redux/action/EmailAction";

// Dialog component handles style dynamically and responsively
const EmailTemplatelistPage = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [open, setOpen] = React.useState(false);

  const [msgBody, setMsgBody] = useState();

  const handleOpen = () => {
    setOpen(true);
    // setScheduleState(true);
  };
  const handleClose = () => setOpen(false);

  const [EmailTemplatelist, setEmailTemplatelist] = useState([]);

  const [table_load, setTable_load] = useState(false);

  const columns = [
    {
      field: "templateName",
      headerName: "template Name",
      width: 250,
    },
    {
      field: "subject",
      headerName: "subject",
      width: 250,
    },
    {
      field: "createdOn",
      headerName: "Template Created Date/Time",
      width: 250,
      renderCell: (params) => {
        return (
          <div>
            {dayjs(params.row.createOn).format("YYYY-MM-DD HH:MM")}
          </div>
        );
      },
    },

    {
      field: "action",
      headerName: "",
      width: 150,
      renderCell: (params) => {
        const handleActionClick = (event) => {
          event.stopPropagation(); // Prevent the row from being selected when clicking the icon
          // dispatch(showSnackbar("This is a success message!", "success"));
          // //("Edit clicked for ID:", params.row.id);
          handleOpen();
          setMsgBody(params.row.body);
        };
        return (
          <div>
            <IconButton onClick={handleActionClick}>
              <Message />
            </IconButton>
          </div>
        );
      },
    },
    {
      field: "action2",
      headerName: "Action",
      width: 150,
      renderCell: (params) => {
        const handleEditActionClick = (event) => {
          event.stopPropagation();
          //(params.row.id)
          navigate(`/CAE/EditMailTemplate/${params.row.id}`);
        };
        return (
          <div className="d-flex" onClick={handleEditActionClick}>
            Edit
          </div>
        );
      },
    },
  ];

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 5,
  });

  const handlePaginationChange = (newPaginationModel, direction) => {
    setPaginationModel(newPaginationModel);
    //('Page Model:', newPaginationModel);
    //('Pagination Direction:', direction); // Logs "left" or "right"
  };
  const EmailTemplatelistState = useSelector(
    (state) => state.email?.emailTemplate?.data?.emailTemplates
  );
  //(EmailTemplatelistState);

  useEffect(() => {
    setTable_load(true);
    dispatch(GetMailTemplateAction());
  }, []);

  useEffect(() => {
    if (Array.isArray(EmailTemplatelistState)) {
      const updatedData = EmailTemplatelistState?.map(
        ({ _id, ...rest }, index) => ({
          id: _id,
          ...rest,
        })
      );
      setEmailTemplatelist(updatedData);
      //(EmailTemplatelistState);
    }
    if (EmailTemplatelistState != undefined) setTable_load(false);
  }, [EmailTemplatelistState]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item lg={8} md={7} xs={12}>
          <div className="d-flex align-items-center">
            <Typography
              fontFamily={FontFamily.Poppins}
              fontWeight={fontWeight.W600}
              fontSize={fontSize.h2.small}
            >
            Email Template List
            </Typography>
          </div>
        </Grid>
        <Grid item lg={4} md={5} xs={12}>
          <Box
            className="d-flex align-items-center w-100"
            sx={{
              justifyContent: {
                sm: "space-between",
                xs: "space-between",
                lg: "end",
                md: "end",
              },
            }}
          >
            <div className="px-2">
              <CustomButton
                variant="contained"
                type="submit"
                backgroundColor={ThemeColor.PURPLE}
                color={ThemeColor.WHITE}
                //   padding={"0px"}
                onClick={() => navigate("/CAE/addMailTemplate")}
              >
                Add Email Template
              </CustomButton>
            </div>

            <div>
              <Settinglist />
            </div>
          </Box>
        </Grid>
      </Grid>
      <div className="table-container" style={{ overflowX: "scroll" }}>
        <CustomDataTable
          row={EmailTemplatelist ? EmailTemplatelist : []}
          columns={columns}
          loading={table_load}
          onPaginationChange={handlePaginationChange}
        />
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: { borderRadius: "16px", p: 1 }
        }}
      >
        <DialogTitle sx={{ fontFamily: FontFamily.Poppins, fontWeight: 700, pb: 1 }}>
          Template Body Preview
        </DialogTitle>
        <DialogContent dividers>
          <Box
            sx={{
              minHeight: "200px",
              fontFamily: FontFamily.Nunito,
              lineHeight: 1.6,
              color: "#334155",
              p: 1
            }}
            dangerouslySetInnerHTML={{ __html: msgBody }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} sx={{ color: "#64748b", fontFamily: FontFamily.Poppins, textTransform: "none", fontWeight: 600 }}>
            Close Preview
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

function EmailTemplatelist() {
  return (
    <div>
      <ResponsiveDrawer maincontent={<EmailTemplatelistPage />} />
    </div>
  );
}

export default EmailTemplatelist;
